import { useEffect } from 'react';
import { useSiteSettings } from '../hooks/useSiteSettings';

const GoogleAnalytics: React.FC = () => {
  const { settings, loading } = useSiteSettings();

  useEffect(() => {
    // Don't do anything while settings are still loading
    if (loading) {
      return;
    }

    if (settings.google_analytics_id && settings.google_analytics_id.trim()) {
      // Check if GA is already loaded
      if (window.gtag) {
        // GA is already loaded, just update the config
        window.gtag('config', settings.google_analytics_id);
        return;
      }

      // Dynamically inject Google Analytics scripts
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${settings.google_analytics_id}`;
      
      // Wait for the first script to load before adding the configuration script
      script1.onload = () => {
        const script2 = document.createElement('script');
        script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${settings.google_analytics_id}');
        `;
        document.head.appendChild(script2);
      };
      
      document.head.appendChild(script1);
    }
  }, [settings.google_analytics_id, loading]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;
